exports = module.exports = require("../../../../../../textelements/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}", ""]);

// exports
